import React, { Component } from 'react';

export default class WorkspaceBottomBar extends Component {

	constructor(props) {
		super(props);

		this.state = {
			arrowClasses: {
				left: " hidden",
				right: " hidden"
			},
			dashboardMenuOpen: false,
			activeTabMenu: null,
			tabMenuLeft: "0rem"
		}

		this.horizontalScroll = this.horizontalScroll.bind(this);
		this.horizontalScrollButton = this.horizontalScrollButton.bind(this);

		this.handleClickWithParentAction = this.handleClickWithParentAction.bind(this);

		this.toggleDashboardMenu = this.toggleDashboardMenu.bind(this);
		this.setTabMenu = this.setTabMenu.bind(this);

		this.generateWorkspaceTabs = this.generateWorkspaceTabs.bind(this);
		this.generateLeftMenus = this.generateLeftMenus.bind(this);
	}

	componentDidMount() {
		if (document.getElementById('workspaces-tab-scroller')) {
			// IE9, Chrome, Safari, Opera
			document.getElementById('workspaces-tab-scroller').addEventListener("mousewheel", this.horizontalScroll, false);
			// Firefox
			document.getElementById('workspaces-tab-scroller').addEventListener("DOMMouseScroll", this.horizontalScroll, false);
		}
	}

	componentWillUnmount() {
		if (document.getElementById('workspaces-tab-scroller')) {
			// IE9, Chrome, Safari, Opera
			document.getElementById('workspaces-tab-scroller').removeEventListener("mousewheel", this.horizontalScroll, false);
			// Firefox
			document.getElementById('workspaces-tab-scroller').removeEventListener("DOMMouseScroll", this.horizontalScroll, false);
		}
	}

	horizontalScroll(e) {
		e = window.event || e;
		var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
		document.getElementById('workspaces-tab-scroller').scrollLeft -= (delta * 60);
		e.preventDefault();

		let arrEl = document.getElementById('workspaces-tab-scroller');
		let arrowClasses = {
			left: arrEl.scrollLeft === 0 ? " hidden" : "",
			right: arrEl.scrollWidth - arrEl.offsetWidth - arrEl.scrollLeft <= 0 ? " hidden" : ""
		}

		if (this.state.arrowClasses.left != arrowClasses.left || this.state.arrowClasses.right != arrowClasses.right) {
			this.setState({ arrowClasses: arrowClasses })
		}
	}

	horizontalScrollButton(delta) {
		if (document.getElementById('workspaces-tab-scroller')) {
			let arrEl = document.getElementById('workspaces-tab-scroller');
			let arrowClasses = {
				left: arrEl.scrollLeft === 0 ? " hidden" : "",
				right: arrEl.scrollWidth - arrEl.offsetWidth - arrEl.scrollLeft <= 0 ? " hidden" : ""
			}

			arrEl.scrollLeft += delta
			if (this.state.arrowClasses.left != arrowClasses.left || this.state.arrowClasses.right != arrowClasses.right) {
				this.setState({ arrowClasses: arrowClasses })
			}
		}
	}

	handleClickWithParentAction(parentFunction, op=null) {
		if(!this.props.isAaBiDashboardOnly || op === 'export') {
			this.setState({ dashboardMenuOpen: false, activeTabMenu: null }, () => {
				parentFunction();
			})
		}
	}

	toggleDashboardMenu(isMenuOpen) {
		if (typeof isMenuOpen != "boolean") {
			isMenuOpen = !this.state.dashboardMenuOpen
		}

		this.setState({ dashboardMenuOpen: isMenuOpen })
	}

	setTabMenu(value) {

		let tabMenuLeft = this.state.tabMenuLeft;
		if (value != null) {
			let rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
			let elOffset = document.getElementById("workspace-tab-id-" + value).offsetLeft;
			let containerScroll = document.getElementById("workspaces-tab-scroller").scrollLeft;
			tabMenuLeft = (((6 * rem) + elOffset - containerScroll) / rem) + "rem";
		}

		this.setState({ activeTabMenu: value, tabMenuLeft: tabMenuLeft });
	}

	generateWorkspaceTabs() {
		let result = [];

		this.props.workspaces.forEach((workspace, i) => {
			result.push((
				<div
					key={`workspace-tab-${workspace.id}-${i}`}
					id={"workspace-tab-id-" + workspace.id}
					className={"tab" + (workspace.id === this.props.activeWorkspaceId ? " active" : "")}
				>
					{!workspace.isExport ? null :
						<div className={"material-icons doc-icon"} onClick={this.props.selectWorkspace.bind(null, workspace.id)}>{"description"}</div>}
					<div className={"name"} onClick={this.props.selectWorkspace.bind(null, workspace.id)}>{workspace[this.props.isDesignMode ? "details" : "publishedDetails"].name}</div>
					<div className={"material-icons drop-icon"} onClick={() => {
						this.props.selectWorkspace(workspace.id);
						this.setTabMenu(workspace.id);
					}}>
						{"arrow_drop_down"}
					</div>
					<div className={"active-bar"}></div>
				</div>
			))
		});

		return result;
	}

	generateLeftMenus() {
		let workspaceMenuItems = []

		let isPublishedIdenticle = false

		this.props.workspaces.forEach(w => {

			if (w.id === this.props.activeWorkspaceId) {
				isPublishedIdenticle = JSON.stringify(w.details) === JSON.stringify(w.publishedDetails);
			}

			workspaceMenuItems.push((
				<div
					className={"option"}
					onClick={this.handleClickWithParentAction.bind(null, this.props.selectWorkspace.bind(null, w.id))}
				>{w[this.props.isDesignMode ? "details" : "publishedDetails"].name}</div>
			))
		})

		let dashboardMenuJsx = null;
		if (this.props.isDesignMode) {
			dashboardMenuJsx = (
				<div className={"dashboard-menu design-mode" + (this.state.dashboardMenuOpen ? "" : " hidden")}>
					<div className={"option" + (isPublishedIdenticle ? " disabled" : "")} onClick={this.handleClickWithParentAction.bind(null, this.props.publishWorkspace)}>{"Publish"}</div>
					<div
						className={"option"}
						onClick={this.handleClickWithParentAction.bind(null,
							zconfirm.bind(null, "Are you sure you would like to restore from the published version? (This cannot be undone.)",
								this.props.restoreWorkspace))}
					>{"Restore"}</div>
					{/*<div className={"option disabled"}>{"Share"}</div>*/}
					<div
						className={"option"}
						onClick={this.handleClickWithParentAction.bind(null,
							zconfirm.bind(null, "Are you sure you would like to delete this dashboard? (This cannot be undone.)",
								this.props.deleteWorkspace.bind(null, this.props.activeWorkspaceId)))}
					>{"Delete"}</div>
					<div
						className={"option"}
						onClick={this.handleClickWithParentAction.bind(null,
							zconfirm.bind(null, "Are you sure you want to clear all visuals for this dashboard? (This cannot be undone.)",
								this.props.clearAllVisuals.bind(null, this.props.activeWorkspaceId)))}
					>{"Clear ALL Visuals"}</div>
					<div className={"option"} onClick={this.handleClickWithParentAction.bind(null, this.props.quitDesignMode)}>{"Exit Design Mode"}</div>
				</div>
			)
		} else {
			dashboardMenuJsx = (
				<div className={"dashboard-menu" + (this.state.dashboardMenuOpen ? "" : " hidden")}>
					<div className={"dashboard-split-side"}>
						<div className={"option" + (!this.props.isAaBiDashboardOnly ? "" : " menu-disable")} onClick={this.handleClickWithParentAction.bind(null, this.props.createWorkspace)}>{"Create"}</div>
						<div className="option" onClick={this.props.openModal.bind(null, "open-workspaces")}>{"Open"}</div>
						<div className={"option" + (!this.props.isAaBiDashboardOnly ? "" : " menu-disable")} onClick={this.handleClickWithParentAction.bind(null, this.props.closeAllWorkspaces)}>{"Close All"}</div>
					</div>
					<div className={"dashboard-split-side scrollable"}>
						{workspaceMenuItems}
					</div>
				</div>
			)
		}

		return (
			<div className={"left-button-container"} >
				{this.props.isDesignMode ?
					(<div className={"material-icons button" + (isPublishedIdenticle ? " disabled" : "") + (this.props.isPublishing ? " highlight" : "")} onClick={this.props.publishWorkspace}>{(this.props.isPublishing ? "cloud_done" : "backup")}</div>)
					:
					(<div className={(!this.props.isAaBiDashboardOnly ? "" : "menu-disable") +  " material-icons button"} onClick={!this.props.isAaBiDashboardOnly ? this.props.createWorkspace : ''}>{"add"}</div>)
				}

				<div className={"button no-pointer"}>
					<span className={"material-icons sub-button"} onClick={this.toggleDashboardMenu.bind(null, true)}>{"dashboard"}</span>
					<div
						className={"dashboard-menu-blocker" + (this.state.dashboardMenuOpen ? "" : " hidden")}
						onClick={this.toggleDashboardMenu.bind(null, false)}
					></div>
					{dashboardMenuJsx}
				</div>
			</div>
		)
	}

	render() {

		let tabMenuStyle = { left: this.state.tabMenuLeft };

		let canEdit = this.props.allWorkspaces.reduce((e, r) => {
			if (r.id == this.props.activeWorkspaceId) {
				e = r.canEdit;
			}
			return e;
		}, false);

		let isSystem = this.props.allWorkspaces.reduce((e, r) => {
			if (r.id == this.props.activeWorkspaceId) {
				e = r.isSystem;
			}
			return e;
		}, false);

		return (
			<div className={"workspace-bottom-bar-outer"}>
				<div className={"design-mode-label" + (this.props.isDesignMode ? "" : " hidden")}>{"DESIGN MODE"}</div>
				{this.generateLeftMenus()}
				<div id={"workspaces-tab-scroller"} className={"scroll-area-container" + (this.props.isDesignMode ? " hidden" : "")}>
					{this.generateWorkspaceTabs()}
				</div>
				<div className={"right-button-container" + (this.props.isDesignMode ? " hidden" : "")}>
					<div className={"material-icons button arrow" + this.state.arrowClasses.left} onClick={this.horizontalScrollButton.bind(null, -120)}>{"arrow_left"}</div>
					<div className={"material-icons button arrow" + this.state.arrowClasses.right} onClick={this.horizontalScrollButton.bind(null, 120)}>{"arrow_right"}</div>
				</div>
				<div className={"menu-blocker" + (this.state.activeTabMenu != null ? " active" : "")} onClick={this.setTabMenu.bind(null, null)}></div>
				<div className={"menu-outer" + (this.state.activeTabMenu != null ? " active" : "")} style={tabMenuStyle}>
					<div data-trackid={'dashboard-menu-design'} className={"option" + (!this.props.isAaBiDashboardOnly ? "" : " menu-disable") + (canEdit ? "" : " disabled")} onClick={canEdit ? this.handleClickWithParentAction.bind(null, this.props.goToDesignMode.bind(null, this.state.activeTabMenu)) : null}>{"Design"}</div>
					<div data-trackid={'dashboard-menu-duplicate'} className={"option" + (!this.props.isAaBiDashboardOnly ? "" : " menu-disable") + (isSystem ? " disabled" : "")} onClick={isSystem ? null : this.handleClickWithParentAction.bind(null, this.props.duplicateWorkspace.bind(null, this.state.activeTabMenu))}>{"Duplicate"}</div>
					<div data-trackid={'dashboard-menu-share'} className={"option" + (!this.props.isAaBiDashboardOnly ? "" : " menu-disable") + (canEdit ? "" : " disabled")} onClick={canEdit ? this.handleClickWithParentAction.bind(null, this.props.openModal.bind(null, "share")) : null}>{"Share"}</div>
					<div data-trackid={'dashboard-menu-export'} className={"option" + (this.props.activeWorkspaceId === null ? " disabled" : "")} onClick={this.handleClickWithParentAction.bind(null, this.props.openModal.bind(null, "export"), 'export')}>{"Export"}</div>
					{/*<div className={"option disabled"}>{"Favorite"}</div>*/}
					<div data-trackid={'dashboard-menu-close'} className={"option" + (!this.props.isAaBiDashboardOnly ? "" : " menu-disable")} onClick={this.handleClickWithParentAction.bind(null, this.props.closeWorkspace.bind(null, this.state.activeTabMenu))}>{"Close"}</div>
				</div>
			</div>
		);
	}
}